export enum TasksStates {
   PENDING = 1,
   IN_PROCESS = 2,
   FINISHED = 3,
   CANCELLED = 4,
// USED TO FRONT END STATES FILTER
   ACTIVE = 5,
   ALL = 6
}
